module.exports = __webpack_public_path__ + "static/img/mynjoi-tvschedule-cover.8ff954b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/mynjoi-tvschedule-cover.png
// module id = 7n6e
// module chunks = 1